module.exports = "/static/media/dashboard_logo_SPK.56bccf1c.svg";